import React from 'react'
import { ComponentData } from '../data/ComponentContext'
import { Col, Row } from 'react-bootstrap'
import CustomSelect from './CustomSelect'


function EnergySelect({ className }) {

  const { EnergySources, zone1Energy, setZone1Energy, zone2Energy, setZone2Energy } = ComponentData()

  return (
    <Col md={12}>
      <div className={className}>
        <div className={'component-box'} >
          <Row className="headline_texts">
            <div className="configuration-text">
              <h3>Energieträger</h3>
            </div>
          </Row>

          <Row>
            <Col md={8}>
              <CustomSelect
                Items={EnergySources}
                value={zone1Energy}
                setValue={setZone1Energy}
                placeholder={'Energieträger wählen'} />
            </Col>
            <Col md={4}>
              <p>Zone 1 / Aufheizen</p>
            </Col>
          </Row>

          <Row>
            <Col md={8}>
              <CustomSelect
                Items={EnergySources}
                value={zone2Energy}
                setValue={setZone2Energy}
                placeholder={'Energieträger wählen'} />
            </Col>
            <Col md={4}>
              <p>Zone 2 / Halten</p>
            </Col>
          </Row>

        </div>
      </div>
    </Col>
  )
}

export default EnergySelect